module.exports = __webpack_public_path__ + "img/kpi-recensement.87ef32a5.svg";